/**
 * Shared styles for SoftphoneCollapsibleCallGroup components.
 * Mirrors the base styling from SoftphoneHeldCalls for consistency.
 */

export const baseClasses = `
  w-full flex items-center justify-between
  cursor-pointer transition-all duration-200
  outline-none
`;

export const triggerClasses = `
  h-[55px]
  px-[16px] py-[8px]
  bg-muted
  focus-visible:ring-1 focus-visible:ring-ring focus-visible:ring-inset
`;
